module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABFCAMAAADEkbAlAAAAPFBMVEXfQGDjVXHbSW3XSHDbSW3ZR3HZSG/YSW7aSW/dV3vfZoflgZzojqbtqLryv8z0y9X54Of76vD99ff///9qU0F7AAAAE3RSTlMICQ4gIzZ4hMzP0tnd5Ovu9fj8fnLn4wAAAIVJREFUWMPt1NkRQjEMQ9GwkwUe8e2/VxpgEs+IT6mA82PJ5XSWU8rjKeduxIgRI0aMGPmdejQZqZNoIlInMDWkTYCXhLRIGBskZ6yRpLFEssYS+QC8xbINgOhiY7PK+jpJZdOTnLJrbErZbmcEEOqKe8CQ/0mP4R9rxIgRI0b+hVxvci5fojyS2dhZeVUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/flick-left.png
// module id = 262
// module chunks = 0